export default __webpack_public_path__ + "dc6f057d3bc6abca57f5ba86213edc7b.png";